module.exports = __webpack_public_path__ + "static/media/capsule_machine_en_ori_3.90f61253.png";